export default __webpack_public_path__ + "static/media/icon-mir.32ac0252.svg";